// frontend/src/pages/NewUINextGames.jsx
import React, { useState, useEffect } from 'react';
import { AlertCircle } from 'lucide-react';
import axios from '../config/axios';

const ComingSoonCard = ({ game }) => (
    <div className="relative bg-[#2284DF] rounded-2xl shadow-lg p-6 cursor-not-allowed opacity-75 min-h-[240px] overflow-hidden">
        {/* Textura de fondo */}
        <div
            className="absolute inset-0 pointer-events-none z-0"
            style={{
                backgroundColor: "#1F79CF",
                WebkitMaskImage: "url(/images/backgrounds/textura-azul.png)",
                maskImage: "url(/images/backgrounds/textura-azul.png)",
                WebkitMaskRepeat: "repeat",
                maskRepeat: "repeat",
                WebkitMaskSize: "1769px 1183px",
                maskSize: "1769px 1183px",
                WebkitMaskPosition: "center",
                maskPosition: "center",
            }}
            aria-hidden="true"
        />

        {/* Contenido */}
        <div className="relative z-10 flex flex-col justify-between h-full">
            <div className="space-y-4">
                <img src={game.logo} alt={game.name} className="h-12 object-contain" />
                <p className="text-white/70 text-sm">{game.shortDesc}</p>
            </div>

            <div className="flex justify-between items-end mt-6">
                <button
                    className="px-6 py-2 bg-gray-400 text-gray-200 rounded-lg font-bold uppercase text-xs tracking-wide cursor-not-allowed"
                    disabled
                >
                    Próximamente
                </button>
                {game.featuredImg && (
                    <div className="w-24 h-24">
                        <img
                            src={game.featuredImg}
                            alt={`${game.name} featured`}
                            className="w-full h-full object-contain opacity-40"
                        />
                    </div>
                )}
            </div>
        </div>
    </div>
);

const NewUINextGames = () => {
    const [games, setGames] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    // Aplicar clase de fuente y overflow
    useEffect(() => {
        document.body.classList.add('acumin-scope');
        document.body.style.overflowX = 'hidden';
        return () => {
            document.body.classList.remove('acumin-scope');
            document.body.style.overflowX = '';
        };
    }, []);

    useEffect(() => {
        const fetchGames = async () => {
            try {
                const response = await axios.get('/games');
                setGames(response.data.data);
            } catch (error) {
                setError(error.response?.data?.message || 'Error al cargar los juegos');
            } finally {
                setIsLoading(false);
            }
        };

        fetchGames();
    }, []);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-[#122436] flex items-center justify-center">
                <div className="animate-spin rounded-full h-16 w-16 border-4 border-white border-t-transparent"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen bg-[#122436] flex items-center justify-center p-4">
                <div className="bg-red-50 text-red-600 p-6 rounded-2xl flex items-center max-w-md shadow-lg">
                    <AlertCircle className="w-6 h-6 mr-3 flex-shrink-0" />
                    <p className="font-semibold">{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#122436] overflow-x-hidden">
            <div className="max-w-[calc(100%-100px)] mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-8">
                <h1 className="toon text-4xl md:text-5xl text-white uppercase tracking-wider mb-8">
                    Juegos en Camino
                </h1>

                <div className="space-y-12">
                    {/* Coming Soon Games */}
                    {games?.comingSoon && games.comingSoon.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {games.comingSoon.map(game => (
                                <ComingSoonCard key={game.id} game={game} />
                            ))}
                        </div>
                    ) : (
                        <div className="flex flex-col items-center justify-center py-20">
                            <p className="text-white/70 text-xl text-center">
                                No hay juegos próximos anunciados en este momento
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NewUINextGames;